import { FileProcessingStatus } from '../domain/enums';
import { IngestionSummary } from '../domain/types';

export const TERMINAL_STATUSES: FileProcessingStatus[] = [
  FileProcessingStatus.Completed,
  FileProcessingStatus.CompletedWithErrors,
  FileProcessingStatus.Failed,
  FileProcessingStatus.Cancelled,
  FileProcessingStatus.Rejected,
];

export const isTerminalStatus = (status: FileProcessingStatus): boolean =>
  TERMINAL_STATUSES.includes(status);

export const hasNonTerminalIngestion = (
  ingestions: IngestionSummary[],
): boolean => ingestions.some(ingestion => !isTerminalStatus(ingestion.status));
